import { render, staticRenderFns } from "./dataprocess-flow-shell.vue?vue&type=template&id=2f640182&scoped=true&"
import script from "./dataprocess-flow-shell.vue?vue&type=script&lang=ts&"
export * from "./dataprocess-flow-shell.vue?vue&type=script&lang=ts&"
import style0 from "./dataprocess-flow-shell.vue?vue&type=style&index=0&id=2f640182&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f640182",
  null
  
)

export default component.exports